import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";

export const BaseTodoBox = ({
	className = "text-primary",
	number,
	title,
	description,
	to,
	readOnly = false,
	subRow,
}: {
	className?: string;
	number?: React.ReactNode;
	title: React.ReactNode;
	description?: React.ReactNode;
	to?: string;
	readOnly?: boolean;
	subRow?: React.ReactNode;
}) => {
	return (
		<Grid
			id={`BaseTodoBox ${title}`}
			size={{
				xs: 12,
				lg: 12,
			}}
		>
			<Paper className={className} sx={{ p: 2 }}>
				<Grid
					container
					sx={{
						alignItems: "center",
					}}
				>
					<Grid
						size={{
							xs: 12,
							lg: 8,
						}}
					>
						<Box>
							<Typography variant="h6" component="h6">
								<Grid
									container
									sx={{
										alignItems: "center",
									}}
								>
									{title}
								</Grid>
							</Typography>
						</Box>
					</Grid>
					<Grid
						size={{
							xs: 12,
							lg: 3,
						}}
					>
						{description}
					</Grid>
					{subRow ? <Grid size={12}>{subRow}</Grid> : null}
				</Grid>
			</Paper>
		</Grid>
	);
};
